import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import PageHeader from "../../components/ui/pageHeader/PageHeader";
import PageLoader from "../../components/ui/pageLoader/PageLoader";
import PageEmpty from "../../components/ui/pageEmpty/PageEmpty";

import AdminDashboard from "./components/AdminDashboard";
import CoachDashboard from "./components/CoachDashboard";

import { getDashboardOverview } from "../../redux/features/dashboard/dashboardSlice";

import { HiOutlineChartBarSquare } from "react-icons/hi2";

import "./DashboardPage.css";

export default function DashboardPage() {
  const dispatch = useDispatch();

  const { overview, isLoading, error } = useSelector(
    (state) => state.dashboard,
  );

  useEffect(() => {
    dispatch(getDashboardOverview());
  }, [dispatch]);

  if (isLoading && !overview) {
    return <PageLoader title="Dashboard laden..." />;
  }

  if (!overview) {
    return (
      <div className="dashboard-page">
        <PageHeader
          eyebrow="POWER"
          title="Dashboard"
          description="Operationeel overzicht van POWER."
        />

        <PageEmpty
          icon={<HiOutlineChartBarSquare />}
          title="Geen dashboardgegevens"
          description={
            error || "Er zijn momenteel geen dashboardgegevens beschikbaar."
          }
        />
      </div>
    );
  }

  return (
    <div className="dashboard-page">
      <PageHeader
        eyebrow="POWER"
        title="Dashboard"
        description={
          overview.active_school_year?.name
            ? `Overzicht voor schooljaar ${overview.active_school_year.name}`
            : "Operationeel overzicht van POWER."
        }
      />

      {error && <div className="dashboard-page__error">{error}</div>}

      {overview.type === "admin" && <AdminDashboard dashboard={overview} />}

      {overview.type === "coach" && <CoachDashboard dashboard={overview} />}
    </div>
  );
}
